module.exports = __webpack_public_path__ + "static/media/6_r_Layer6_87.24_32.22.54f613e5.png";